// extracted by mini-css-extract-plugin
export var barContainer = "_25-0";
export var extraThin = "_25-3";
export var fillBar = "_25-6";
export var fillContainer = "_25-4";
export var overflow = "_25-8";
export var overflowContainer = "_25-5";
export var regular = "_25-7";
export var thick = "_25-1";
export var thin = "_25-2";